import sanitize from 'sanitize-html'
import { escape } from 'validator'

const SANITIZE_OPTIONS: sanitize.IOptions = {
  allowedAttributes: {},
  allowedTags: [],
}

const sanitizeString = (input: string): string => {
  return escape(sanitize(input, SANITIZE_OPTIONS))
}

export const trySanitize = <T>(input: T, escape = true, maxLength?: number): T => {
  if (typeof input === 'string') {
    const sanitized = escape ? sanitizeString(input) : sanitize(input, SANITIZE_OPTIONS)

    if (maxLength && sanitized.length > maxLength) {
      throw new Error(`Input exceeds maximum length of ${maxLength} characters`)
    }

    return sanitized as T
  }

  if (typeof input !== 'object' || input === null) {
    return input
  }

  if (Array.isArray(input)) {
    return input.map(item => trySanitize(item, escape, maxLength)) as T
  }

  return Object.fromEntries(
    Object.entries(input).map(([key, value]) => [key, trySanitize(value, escape, maxLength)]),
  ) as T
}
